import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const colorMap: Record<string, string> = {
  primary: "bg-primary-50 text-primary-600",
  accent: "bg-accent-50 text-accent-600",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:border-primary-300 hover:bg-primary-50/50"
        >
          <span
            className={`flex h-11 w-11 items-center justify-center rounded-lg ${
              colorMap[cat.color] ?? colorMap.primary
            }`}
          >
            <i className={`${cat.icon} text-2xl`} aria-hidden="true"></i>
          </span>
          <div>
            <h3 className="text-base font-medium text-foreground-950 transition-colors group-hover:text-primary-600">
              {cat.name}
            </h3>
            <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-500">{cat.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}